import DollarIcon from '@shared/assets/dollar.png';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getLastDollarRate } from '@shared/services/services';
import ExchangeRate from './ExchangeRate';
import { Button, Typography, Box, useTheme } from '@mui/material';
import useWindowSize from '@shared/hooks/useWindowsSize';
import { CustomDialogModal } from '@shared/components/Dialogs';

const DollarHeader = ({ detail }) => {
  const [bspAndGitDollarValue, setBspAndGitValue] = useState([]);
  const [showModalMap, setShowModalMap] = useState(false);
  const screenSize = useWindowSize();
  const pageConfiguration = useSelector(store => store.pageConfiguration);

  const theme = useTheme();

  const fetchDollarGitAndBsp = async () => {
    try {
      let result = await getLastDollarRate();
      setBspAndGitValue(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (pageConfiguration.site_functions.showDollarInfo) {
      fetchDollarGitAndBsp();
    }
  }, []);

  const formatter = new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  let gitDollarDisplay = 'N/A';

  if (bspAndGitDollarValue.length > 0) {
    const value = bspAndGitDollarValue[0]?.money_value;
    gitDollarDisplay =
      value === 0 ? 'Consultar' : formatter.format(Number(value));
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        backgroundColor: theme?.headerColor || 'transparent',
        px: 2,
        py: 1,
        position: detail ? 'fixed' : 'relative',
        zIndex: detail ? 1000 : 'auto',
      }}
    >
      {/* Izquierda: Tipo de cambio en desktop */}
      {screenSize.width > 460 && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography
            sx={{
              fontFamily: 'Open Sans, sans-serif',
              fontSize: 16,
              color: '#000000DE',
            }}
          >
            Tipo de Cambio
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Open Sans, sans-serif',
              fontSize: 16,
              color: '#000000DE',
            }}
          >
            {`Dolar GIT: ${gitDollarDisplay}`}
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Open Sans, sans-serif',
              fontSize: 16,
              color: '#000000DE',
            }}
          >
            {`Dolar BSP: ${
              bspAndGitDollarValue.length > 1
                ? formatter.format(Number(bspAndGitDollarValue[1]?.money_value))
                : 'N/A'
            }`}
          </Typography>
        </Box>
      )}

      {/* Centro o icono para mobile */}
      {screenSize.width <= 460 && (
        <Box>
          <img
            src={DollarIcon}
            alt="Dollar Icon"
            style={{ width: 24, height: 24 }}
          />
        </Box>
      )}

      {/* Derecha: Botón */}
      {screenSize.width > 460 && (
        <Button
          onClick={() => setShowModalMap(true)}
          sx={{
            fontFamily: 'Open Sans, sans-serif',
            fontSize: 16,
            fontWeight: 'normal',
            color: '#000000DE',
            textTransform: 'none',
          }}
        >
          Historial
        </Button>
      )}

      {/* Modal */}
      <CustomDialogModal
        open={showModalMap}
        onClose={() => setShowModalMap(false)}
      >
        <ExchangeRate />
      </CustomDialogModal>
    </Box>
  );
};

export default DollarHeader;
